define('redactor/src/behavior/horizontally.scrollable.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var HorizontallyScrollableBehavior = Mn.Behavior.extend({
    defaults: {
      redactorHeight: 34,
      scrollbarHeight: 15
    },

    initialize: function() {
      this.once('render', function() {
        if (this.view.getOption('horizontallyScrollable')) {
          this.setupHorizontalScroll();
        }
      })
    },

    setupHorizontalScroll: function() {
      if (this.view.$redactor) {
        this.createHiddenSlidebar();

        this.listenTo(this.view, 'focus', function() {
          this.view.$redactor.css('text-overflow', 'initial');
        });

        this.listenTo(this.view, 'blur', function() {
          this.view.$redactor.scrollLeft(0);
          this.view.$redactor.css('text-overflow', 'ellipsis');
        });
      }
    },

    createHiddenSlidebar: function() {
      var self = this;
      var scrollbarHeight = this.getOption('scrollbarHeight');
      var redactorHeight = this.getOption('redactorHeight');

      // var observer = new MutationObserver(function(mutations) {
      //   var redactorHeight = self.view.$redactor.css('height');
      //   self.$el.css('height', parseInt(redactorHeight) - parseInt(scrollbarHeight));
      // });
      // observer.observe(this.view.$redactor.get(0), {
      //   childList: true,
      //   subtree: true,
      //   attributes: true
      // });

      this.$el.css('overflow', 'hidden');
      this.$el.css('height', parseInt(redactorHeight) - parseInt(scrollbarHeight));
      this.view.$redactor.css('overflow-x', 'scroll');
    }
  });
  module.exports = HorizontallyScrollableBehavior;
});

